(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[586],{

/***/ 1548:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artworks",
      function () {
        return __webpack_require__(8642);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _features_pages_ArtworksPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4461);



const Artworks = (param)=>{
    let { catalog , filters  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_pages_ArtworksPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        catalog: catalog,
        filters: filters
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Artworks);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,144,686,233,317,604,461,774,888,179], function() { return __webpack_exec__(1548); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);